module.exports = __webpack_public_path__ + "img/FI25573083.ba8fcaf4.png";